import { Controller } from "stimulus";
const MAX_FILE_SIZE = 10485760;

export default class extends Controller {
  initialize() {
    this.documentsCheckboxes = document.getElementsByClassName("transport-order-document");
    this.limitText = document.getElementById("transport_email_bytes_limit");
    this.submitButton = document.getElementById("send-transport-order-btn");
    this.textDefiner(0);
  }

  documentsChange() {
    let file_size = 0;

    Array.prototype.forEach.call(this.documentsCheckboxes, function (el) {
      if (el.checked) {
        file_size += +el.dataset.size;
      }
    });

    this.textDefiner(file_size);
    this.submitButton.disabled = MAX_FILE_SIZE <= file_size;
    if (MAX_FILE_SIZE <= file_size) {
      this.limitText.classList.add("text-danger");
    } else {
      this.limitText.classList.remove("text-danger");
    }
  }

  textDefiner(size) {
    this.limitText.innerHTML = `Used ${Math.round(size / 1024)} KB out of ${Math.round(
      MAX_FILE_SIZE / 1024
    )} KB`;
  }
}
